import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import "./styles/app.css";
import "./styles/theme-controls.css";
import "./styles/theme-compat.css";
import "./styles/print.css";
import "./styles/report-document.css";
import App from "./App.jsx";
import AppTooltips from "./components/shared/AppTooltips.jsx";
import AppErrorBoundary from "./components/app/AppErrorBoundary.jsx";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <AppErrorBoundary>
        <AppTooltips />
        <App />
      </AppErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>
);

// Production/Plex only: cache the application shell so an inspector who has
// opened ClaimsDesk can reopen the mobile workspace without reception. Vite's
// development HMR must never be cached by a service worker.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/inspection-sw.js").catch(() => {});
  });
}
